import WPAPI from 'wpapi'
const wp = new WPAPI({ endpoint: 'http://admin.kk-obi.com/wp-json' });

import store from '../../store'
import { getCategoriesListSuccess } from '../actions/base-actions';
// import { getStoriesInCategorySuccess } from '../actions/category-actions';


/**
 * Get Category List
 */

export function getCategoriesList() {
  return wp.categories().order('asc').get().then(response => {
    store.dispatch(getCategoriesListSuccess(response));
    return response;
  });
}




/** WEBPACK FOOTER **
 ** ./src/js/api/category-api.js
 **/